import { render, staticRenderFns } from "./EmailAccountVerification.vue?vue&type=template&id=67c51126&"
import script from "./EmailAccountVerification.vue?vue&type=script&lang=js&"
export * from "./EmailAccountVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports